import gql from 'graphql-tag';

export const registerChipResellerQuery = gql`
  mutation NANO_applyV2RegisterChipReseller($input: RegisterChipResellerInputV2!) {
    registerChipResellerV2(input: $input) {
      id
      taxExemptType
    }
  }
`;
